import React, { Fragment, useEffect, useState } from "react";
import { Link, usePage } from "@inertiajs/inertia-react";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import cx from "classnames";
import { XIcon } from "@heroicons/react/solid";
import {
    BellIcon,
    ChatIcon,
    ChipIcon,
    CogIcon,
    HomeIcon,
    ReceiptTaxIcon,
    UserGroupIcon,
    UsersIcon,
} from "@heroicons/react/outline";

export default ({ sidebarOpen, setSidebarOpen }) => {
    let navigation = [
        {
            name: "Dashboard",
            route: route("dashboard"),
            icon: HomeIcon,
            current: route().current("dashboard"),
        },
        {
            name: "Notifications",
            route: route("notifications"),
            icon: BellIcon,
            current: route().current("notifications"),
            count: 5,
        },
        {
            name: "Student",
            icon: UsersIcon,
            current: route().current("students*"),
            children: [
                { name: "Overview", route: route("students") },
                { name: "Import", route: route("students.import") },
            ],
        },
        {
            name: "Group",
            icon: UserGroupIcon,
            current: route().current("groups*"),
            children: [
                { name: "Overview", route: route("groups") },
                { name: "Add Group", route: route("groups.create") },
            ],
        },
        {
            name: "Fee",
            icon: ReceiptTaxIcon,
            current: route().current("fees") || route().current("fees.import"),
            children: [
                { name: "Overview", route: route("fees") },
                { name: "Import", route: route("fees.import") },
            ],
        },
        {
            name: "Fee Alert",
            icon: ChipIcon,
            current: route().current("fees.alert*"),
            children: [
                { name: "Simple", route: route("fees.alert") },
                { name: "Group", route: route("fees.alert.group") },
                { name: "Advance", route: route("fees.alert.advance") },
            ],
        },
        {
            name: "SMS Alert",
            icon: ChatIcon,
            current: route().current("sms.alert.*"),
            children: [
                { name: "Quick SMS", route: route("sms.alert.quick") },
                // { name: "Dynamic SMS", route: route("sms.alert.dynamic") },
            ],
        },
        // {
        //     name: "Scheduled SMS",
        //     icon: CalendarIcon,
        //     route: null,
        // },
        {
            name: "Settings",
            icon: CogIcon,
            current: route().current("settings.*"),
            children: [
                { name: "User Management", route: route("settings.users") },
                {
                    name: "SMS Template Management",
                    route: route("settings.sms.config"),
                },
            ],
        },
    ];

    const {
        auth: { user, notification_count },
    } = usePage().props;

    const [count, setCount] = useState(notification_count);

    useEffect(() => {
        setCount(notification_count);
    }, [notification_count]);

    return (
        <>
            <Transition.Root show={sidebarOpen} as={Fragment}>
                <Dialog
                    as={"div"}
                    className={"fixed inset-0 z-40 flex md:hidden"}
                    onClose={setSidebarOpen}
                >
                    <Transition.Child
                        as={Fragment}
                        enter={"transition-opacity ease-linear duration-300"}
                        enterFrom={"opacity-0"}
                        enterTo={"opacity-100"}
                        leave={"transition-opacity ease-linear duration-300"}
                        leaveFrom={"opacity-100"}
                        leaveTo={"opacity-0"}
                    >
                        <Dialog.Overlay
                            className={
                                "fixed inset-0 bg-gray-600 bg-opacity-75"
                            }
                        />
                    </Transition.Child>
                    <Transition.Child
                        as={Fragment}
                        enter={"transition ease-in-out duration-300 transform"}
                        enterFrom={"-translate-x-full"}
                        enterTo={"translate-x-0"}
                        leave={"transition ease-in-out duration-300 transform"}
                        leaveFrom={"translate-x-0"}
                        leaveTo={"-translate-x-full"}
                    >
                        <div
                            className={
                                "relative w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4"
                            }
                        >
                            <Transition.Child
                                as={Fragment}
                                enter={"ease-in-out duration-300"}
                                enterFrom={"opacity-0"}
                                enterTo={"opacity-100"}
                                leave={"ease-in-out duration-300"}
                                leaveFrom={"opacity-100"}
                                leaveTo={"opacity-0"}
                            >
                                <div className="absolute top-0 right-0 -mr-12 py-2">
                                    <button
                                        onClick={() => setSidebarOpen(false)}
                                        className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                    >
                                        <span className={"sr-only"}>
                                            Close sidebar
                                        </span>
                                        <XIcon
                                            className="h-6 w-6 text-white"
                                            aria-hidden={true}
                                        />
                                    </button>
                                </div>
                            </Transition.Child>
                            <div
                                className={
                                    "flex flex-shrink-0 items-center px-4"
                                }
                            >
                                <img
                                    className={"h-8 w-auto"}
                                    src="/images/logo.png"
                                    alt="logo"
                                />
                            </div>
                            <div className={"mt-5 flex-1 overflow-y-auto"}>
                                <nav className={"space-y-1 px-2"}>
                                    {navigation.map((item) =>
                                        !item.children ? (
                                            <div key={item.name}>
                                                <Link
                                                    href={item.route}
                                                    className={cx(
                                                        "group flex w-full items-center rounded-md py-2 pl-2 text-sm font-medium",
                                                        {
                                                            "bg-gray-100 text-gray-900":
                                                                item.current,
                                                            "hover-text-gray-900 bg-white text-gray-600 hover:bg-gray-50":
                                                                !item.current,
                                                        }
                                                    )}
                                                    onClick={() =>
                                                        setSidebarOpen(false)
                                                    }
                                                >
                                                    <item.icon
                                                        className={cx(
                                                            "mr-3 h-6 w-6 flex-shrink-0",
                                                            {
                                                                "text-gray-500":
                                                                    item.current,
                                                                "text-gray-400 group-hover:text-gray-500":
                                                                    !item.current,
                                                            }
                                                        )}
                                                        aira-hidden="true"
                                                    />
                                                    {item.name}
                                                </Link>
                                            </div>
                                        ) : (
                                            <Disclosure
                                                as={"div"}
                                                key={item.name}
                                                className={"space-y-1"}
                                            >
                                                {({ open }) => (
                                                    <>
                                                        <Disclosure.Button
                                                            className={cx(
                                                                "group flex w-full items-center rounded-md py-2 pl-2 pr-1 text-left text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500",
                                                                {
                                                                    "bg-gray-100 text-gray-900":
                                                                        item.current,
                                                                    "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900":
                                                                        !item.current,
                                                                }
                                                            )}
                                                        >
                                                            <item.icon
                                                                className={
                                                                    "mr-3 h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                                                                }
                                                                aria-hidden={
                                                                    "true"
                                                                }
                                                            />
                                                            <span
                                                                className={
                                                                    "flex-1"
                                                                }
                                                            >
                                                                {item.name}
                                                            </span>
                                                            <svg
                                                                className={cx(
                                                                    "ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out group-hover:text-gray-400",
                                                                    {
                                                                        "rotate-90 text-gray-400":
                                                                            open,
                                                                        "text-gray-300":
                                                                            !open,
                                                                    }
                                                                )}
                                                                viewBox="0 0 20 20"
                                                                aria-hidden="true"
                                                            >
                                                                <path
                                                                    d="M6 6L14 10L6 14V6Z"
                                                                    fill="currentColor"
                                                                />
                                                            </svg>
                                                        </Disclosure.Button>
                                                        <Disclosure.Panel
                                                            className={
                                                                "space-y-1"
                                                            }
                                                        >
                                                            {item.children.map(
                                                                (subItem) => (
                                                                    <Link
                                                                        key={
                                                                            subItem.name
                                                                        }
                                                                        href={
                                                                            subItem.route
                                                                        }
                                                                        className={
                                                                            "group flex w-full items-center rounded-md py-2 pl-11 pr-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                                                                        }
                                                                        onClick={() =>
                                                                            setSidebarOpen(
                                                                                false
                                                                            )
                                                                        }
                                                                    >
                                                                        {
                                                                            subItem.name
                                                                        }
                                                                    </Link>
                                                                )
                                                            )}
                                                        </Disclosure.Panel>
                                                    </>
                                                )}
                                            </Disclosure>
                                        )
                                    )}
                                </nav>
                            </div>
                        </div>
                    </Transition.Child>
                    <div className={"w-14 flex-shrink-0"} aria-hidden={true}>
                        {/*Dummy element to force sidebar to shrink to fit close icon*/}
                    </div>
                </Dialog>
            </Transition.Root>

            {/* Static Sidebar for desktop */}
            <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
                <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
                    <div className="flex-items-center flex flex-shrink-0 flex-row px-4">
                        <img
                            src="/images/logo.png"
                            alt="Logo"
                            className="h-8 w-auto"
                        />
                        <span className="align-middle text-2xl font-extrabold text-green-600">
                            Motherland
                        </span>
                    </div>
                    <div className="mt-5 flex flex-grow flex-col">
                        <nav
                            className="flex-1 space-y-1 px-2 pb-4"
                            aria-label={"sidebar"}
                        >
                            {navigation.map((item) =>
                                !item.children ? (
                                    <div key={item.name}>
                                        <Link
                                            href={item.route}
                                            className={cx(
                                                "group flex w-full items-center rounded-md py-2 pl-2 text-sm font-medium",
                                                {
                                                    "bg-gray-100 text-gray-900":
                                                        item.current,
                                                    "hover-text-gray-900 bg-white text-gray-600 hover:bg-gray-50":
                                                        !item.current,
                                                }
                                            )}
                                        >
                                            <item.icon
                                                className={cx(
                                                    "mr-3 h-6 w-6 flex-shrink-0",
                                                    {
                                                        "text-gray-500":
                                                            item.current,
                                                        "text-gray-400 group-hover:text-gray-500":
                                                            !item.current,
                                                    }
                                                )}
                                                aira-hidden="true"
                                            />
                                            {item.name}
                                        </Link>
                                    </div>
                                ) : (
                                    <Disclosure
                                        as={"div"}
                                        key={item.name}
                                        className={"space-y-1"}
                                    >
                                        {({ open }) => (
                                            <>
                                                <Disclosure.Button
                                                    className={cx(
                                                        "group flex w-full items-center rounded-md py-2 pl-2 pr-1 text-left text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500",
                                                        {
                                                            "bg-gray-100 text-gray-900":
                                                                item.current,
                                                            "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900":
                                                                !item.current,
                                                        }
                                                    )}
                                                >
                                                    <item.icon
                                                        className={
                                                            "mr-3 h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                                                        }
                                                        aria-hidden={"true"}
                                                    />
                                                    <span className={"flex-1"}>
                                                        {item.name}
                                                    </span>
                                                    <svg
                                                        className={cx(
                                                            "ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out group-hover:text-gray-400",
                                                            {
                                                                "rotate-90 text-gray-400":
                                                                    open,
                                                                "text-gray-300":
                                                                    !open,
                                                            }
                                                        )}
                                                        viewBox="0 0 20 20"
                                                        aria-hidden="true"
                                                    >
                                                        <path
                                                            d="M6 6L14 10L6 14V6Z"
                                                            fill="currentColor"
                                                        />
                                                    </svg>
                                                </Disclosure.Button>
                                                <Disclosure.Panel
                                                    className={"space-y-1"}
                                                >
                                                    {item.children.map(
                                                        (subItem) => (
                                                            <Disclosure.Button
                                                                key={
                                                                    subItem.name
                                                                }
                                                                as={Link}
                                                                href={
                                                                    subItem.route
                                                                }
                                                                className={
                                                                    "group flex w-full items-center rounded-md py-2 pl-11 pr-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                                                                }
                                                            >
                                                                {subItem.name}
                                                            </Disclosure.Button>
                                                        )
                                                    )}
                                                </Disclosure.Panel>
                                            </>
                                        )}
                                    </Disclosure>
                                )
                            )}
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
};
